import { render } from "./RatingRange.vue?vue&type=template&id=4004c824"
import script from "./RatingRange.vue?vue&type=script&lang=js"
export * from "./RatingRange.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__